import { Box, Stack, Typography } from "@mui/material";
import { BankImage } from "Components/Shared/BankImage";
import { StarRating } from "Components/Shared/BanksList/BankButton/Components/StarRating";
import type { Bank } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";
import { Resources, useResource } from "Translations/Resources";

const BankNameResources = Resources.BankNames;

type Props = {
  bank: Bank;
  isInModal?: boolean;
};

export const Header = ({ bank, isInModal }: Props) => {
  const { t } = useResource();

  const bankName = (
    <Typography variant="h5" fontWeight="medium">
      {t(BankNameResources[bank])}
    </Typography>
  );

  const bankImage = (
    <BankImage
      bank={bank}
      size="normal"
      heightOverride={isInModal ? 37 : 48}
      widthOverride="auto"
    />
  );

  const rating = Number(t(Resources.BankRating.Banks[bank].Rating)) || 0;
  const currentRating = (
    <Typography color="text.secondary">
      {t(Resources.BankRating.Detail.CurrentRating, { rating })}
    </Typography>
  );

  if (isInModal) {
    return (
      <Stack gap={1}>
        {bankName}
        <HorizontalGroup>
          <Stack gap={1}>
            <StarRating rating={rating} />
            {currentRating}
          </Stack>
          {bankImage}
        </HorizontalGroup>
      </Stack>
    );
  }

  return (
    <HorizontalGroup>
      <Stack gap={1}>
        {bankName}
        <StarRating rating={rating} />
        {currentRating}
      </Stack>
      {bankImage}
    </HorizontalGroup>
  );
};

const HorizontalGroup = ({ children }: { children: ReactNode }) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="flex-start"
    gap={2}
  >
    {children}
  </Box>
);
